import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useOutletContext } from "react-router-dom";
import AIContainer from "./components/AIAgent/AIContainer";
import LearnerContentFrame from "./components/LearnerContentFrame";
import { UserContext } from "../../UserContext";
import { apiFetch } from "../../services/apiFetch";

const apiBaseURL = process.env.REACT_APP_BACKEND_API_URL;
const FALLBACK_SUBSECTION = {
  id: "general_reflection_agent",
  subsection_url: "general_reflection_agent",
  type: "ai",
  title: "Reflection Room",
};

const ReflectionRoomPage = () => {
  const { layoutPhase, setLayoutPhase } = useOutletContext();
  const { user } = useContext(UserContext);
  const [subsection, setSubsection] = useState(null);
  const [loading, setLoading] = useState(true);
  const userId = user?.user_id;

  useEffect(() => {
    let isMounted = true;

    const loadReflectionSubsection = async () => {
      try {
        const response = await apiFetch(`${apiBaseURL}/courses`);
        const data = await response.json();
        if (!isMounted) return;

        const courses = Array.isArray(data) ? data : [];
        let found = null;

        for (const course of courses) {
          for (const module of course.modules || []) {
            const match = (module.subsections || []).find(
              (section) => section.subsection_url === "general_reflection_agent"
            );
            if (match) {
              found = match;
              break;
            }
          }
          if (found) break;
        }

        setSubsection(found || null);
      } catch (error) {
        console.error("Failed to load reflection subsection:", error);
        if (isMounted) {
          setSubsection(null);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadReflectionSubsection();

    return () => {
      isMounted = false;
    };
  }, []);

  const handleToggleImmersive = useCallback(
    (flagOrPhase) => {
      if (typeof flagOrPhase === "string") {
        setLayoutPhase(flagOrPhase);
      } else {
        setLayoutPhase(flagOrPhase ? "immersive" : "intro");
      }
    },
    [setLayoutPhase]
  );

  const resolvedSubsection = useMemo(
    () => subsection || FALLBACK_SUBSECTION,
    [subsection]
  );

  return (
    <LearnerContentFrame layoutPhase={layoutPhase}>
      {loading ? (
        <div className="p-10 text-sm text-gray-500 font-gotham">Loading Reflection Room...</div>
      ) : (
        <AIContainer
          userId={userId}
          subsection={resolvedSubsection}
          onToggleImmersive={handleToggleImmersive}
        />
      )}
    </LearnerContentFrame>
  );
};

export default ReflectionRoomPage;
